import Link from "next/link";

import { Media } from "@/components/elements/Media";

import styles from "./styles.module.css";

const CardUiBodyMedia = ({ href, imgSrc, imgHover, alt, children = null }) => {
  return (
    <div className={styles.figureWrapper}>
      <Link href={href}>
        <Media
          className={styles.figure}
          src={imgSrc}
          imgHover={imgHover}
          alt={alt}
          aspectRatio="landscape"
          objectFit="cover"
          priority
          sizes={"(max-width: 800px) 100vw, (max-width: 992px) 50vw, 33vw"}
        />
      </Link>
      {children}
    </div>
  );
};

export default CardUiBodyMedia;
